export default [
  {
    path: '/workOrder',
    name:"workOrder",
    component: () => import(/* webpackChunkName: 'root' */ '@/views/home'),
    children: [
      {
        path: '/workOrder/list',
        meta: { requireLogin: false },
        component: () => import(/* webpackChunkName: 'root' */ '@/views/work-order/work-order-list/index')
      },
      {
        path: '/workOrder/detail',
        meta: { requireLogin: false },
        component: () => import(/* webpackChunkName: 'root' */ '@/views/work-order/work-order-list/addWorkOrder')
      },
      {
        path: '/workOrder/rule',
        meta: { requireLogin: false },
        component: () => import(/* webpackChunkName: 'root' */ '@/views/work-order/work-order-rule/index')
      },
      {
        path: '/workOrder/rule/detail',
        meta: { requireLogin: false },
        component: () => import(/* webpackChunkName: 'root' */ '@/views/work-order/work-order-rule/addWorkLogic')
      },
    ]
  },
]
